import { ASYNC_ERROR_POSTFIX } from 'utils/ActionCreator'
import { navigateTo } from 'utils/navigation'
import S from 'utils/sentences'
import { URL_CONST } from 'utils/urlConsts'

import {
  selectActualCompanyId,
  selectSelfCompanyId,
  selectSelfIsPartner,
  selectUserEmail,
  selectUserId,
} from 'containers/App/selectors'

import * as Sentry from '@sentry/browser'

export const requestErrorHandler = (store) => (next) => (action) => {
  if (action.error && action.type.endsWith(ASYNC_ERROR_POSTFIX)) {
    const expectedErrorCodes = Array.isArray(action.error.expectedErrorCodes)
      ? action.error.expectedErrorCodes
      : []

    if (action.error.status === 401) {
      const url = URL_CONST.login.signin
      const message = action.error.response?.message || S.SESSION_EXPIRED
      if (typeof window.showPreloader === 'function') window.showPreloader()
      const params = new URLSearchParams()
      if (message) params.set('error', message)
      params.set('next', window.location.pathname + window.location.search)
      navigateTo(`${url}?${params.toString()}`)
    } else if (
      window.SENTRY_INITIALIZED &&
      Number(action.error.status) !== 0 &&
      Number(action.error.status) < 500 &&
      !expectedErrorCodes.includes(action.error.status)
    ) {
      const state = store.getState()
      Sentry.captureException(new Error(`[${action.error.status}] ${action.type}`), {
        user: {
          id: selectUserId(state),
          email: selectUserEmail(state),
        },
        extra: {
          action,
          response: action.error.response,
        },
        tags: {
          source: 'error during async action',
          statusCode: action.error.status,
          companyId: selectSelfCompanyId(state),
          msp: selectSelfIsPartner(state),
          selectedCompanyId: selectActualCompanyId(state),
        },
        fingerprint: [action.error.status, action.type],
      })
    }
  }
  return next(action)
}
